import { render, staticRenderFns } from "./InternationalForm.vue?vue&type=template&id=428906f6&scoped=true"
import script from "./InternationalForm.vue?vue&type=script&lang=js"
export * from "./InternationalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428906f6",
  null
  
)

export default component.exports